import UserRoleModel from "@/components/Forms/User/models/userRoleModel";
import UserRightModel from "@/components/Forms/User/models/userRightModel";

class UserModel {
  id = null;
  name = null;
  login = null;
  hash = null;
  rights = [];
  roles = [];

  constructor(userDataRaw) {
    if (userDataRaw !== undefined) {
      let userData = JSON.parse(JSON.stringify(userDataRaw));
      let { id, name, login, rights, roles } = userData;
      Object.assign(this, {
        id,
        name,
        login
      });
      this.rights = rights.map(right => new UserRightModel(right));
      this.roles = roles.map(role => new UserRoleModel(role));
    }
  }
}
export default UserModel;
